<template>
  <div style="margin: 0 48px 8px 24px;">
    <el-form ref="formRef" :model="shopForm" label-width="auto" label-position="right">
      <el-form-item label="所属门店：">
          {{shopForm.shopName}}
      </el-form-item>
      <el-form-item label="打卡启用时间：">
        <el-date-picker
            v-model="openDate"
            type="date"
            placeholder="请选择启用日期"
            format="YYYY-MM-DD"
            value-format="YYYY-MM-DD"
            style="width: 100%"
            :disabled-date="disabledDate"
        />
      </el-form-item>
      <el-form-item label="周打卡上传截止时间：">
        <el-select v-model="weekClose" placeholder="Select" class="select-item">
          <el-option v-for="item in weekCloseArray" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="月打卡上传截止时间：">
        <el-select v-model="monthClose" placeholder="Select" class="select-item">
          <el-option v-for="item in monthCloseArray" :key="item" :label="item" :value="item">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div class="dialog-footer" style="text-align: center; margin-top: 24px;">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit" :disabled="loading" v-loading="loading" >确定</el-button>
    </div>
  </div>

</template>

<script>
import { postFormData, getFormData, imgPostFormData } from "@/api/api"
import { updateShopHygiene} from "@/api/url";
import { phoneReg, greaterIntReg } from "@/assets/shared/reg-constant";

export default {
  name: "BannerDialog",
  props: {
    value: Object
  },
  data() {
    return {
      shopForm: this.value.shopForm,
      idx: this.value.ids,
      openDate: this.value.shopForm.openDate?this.value.shopForm.openDate:'',
      weekClose: this.value.shopForm.weekClose?this.value.shopForm.weekClose:3,
      weekCloseArray: [
        {label:'周日', value: 1},
        {label:'周一', value: 2},
        {label:'周二', value: 3},
        {label:'周三', value: 4},
        {label:'周四', value: 5},
        {label:'周五', value: 6},
        {label:'周六', value: 7},
      ],
      monthClose: this.value.shopForm.monthClose?this.value.shopForm.monthClose:10,
      monthCloseArray: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31],
      loading: false
    }
  },
  methods: {

    disabledDate(time) {
      let today = new Date()

      return time.getTime() < (today.getTime() - 24*60*60*1000)
    },

    //更改或添加
    headImgUpdate() {
      this.$refs.headImg.click();
    },

    //选取图片
    headImgChanged(e) {
      if(e.target.files[0]) {
        this.files = e.target.files[0];
        var windowURL = window.URL || window.webkitURL;
        this.src = windowURL.createObjectURL(this.files);
      }
    },

    cancel() {
      this.$emit("close");
    },
    summit() {
      if(!this.openDate) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '打卡启用时间不能为空',
          type: 'warning'
        });
        return false
      }
      this.loading = true
      let param = {};
      param['id'] = this.shopForm.id;
      param['openDate'] = this.openDate;
      param['weekClose'] = this.weekClose;
      param['monthClose'] = this.monthClose;
      postFormData(updateShopHygiene, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm', param)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
        this.loading = false
      })
    },


  },
  mounted() {

  }
}
</script>

<style scoped>
.add {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border: 1px dashed #ececec;
  font-size: 30px;
  cursor: pointer;
  margin: 0 auto
}
</style>
